export const SORT_ORDER = {
  ascend: 'asc',
  descend: 'desc',
};
